import { createContext, useEffect, useRef, useState } from "react";
import { getQuoteList } from "../Services/QuoteService";
import { HTTP_RESPONSE_CODES } from "../../../globals/globals";
import { set } from "react-hook-form";
import {
  localStorageRemove,
  localStorageSave,
} from "../../../services/localStorageService";

const QuoteOrderContext = createContext();
const localStoragePrefix = "supplychain/quote-tracking/quote/draft";
const QuoteOrderContextProvider = ({ children }) => {
  const pageSize = 20;
  const [filters, setFilters] = useState({ dropdowns: {}, txt: {} });
  const [loadingQuotes, setLoadingQuotes] = useState(false);
  const [isOnEdition, setIsOnEdition] = useState(false);
  const [page, setPage] = useState(0);
  const [maxPages, setMaxPages] = useState(null);
  const [search, setSearch] = useState("");
  const didMount = useRef(false);
  const [sortingOrder, setSortingOrder] = useState("id");
  const [updateInfoList, setUpdateInfoList] = useState(null);
  const [quoteList, setQuoteList] = useState([]);
  const [quoteVendorFormState, setQuoteVendorFormState] = useState({});
  const [quoteToOrderList, setQuoteToOrderList] = useState([]);
  const [drafts, setDrafts] = useState(
    getDraftContentsByPrefix(localStoragePrefix)
  );
  useEffect(() => {
    window.addEventListener("keydown", handleEnterKey);
    return () => {
      window.removeEventListener("keydown", handleEnterKey);
    };
  }, []);
  const handleEnterKey = (event) => {
    console.log("Key pressed:", event.key);
    if (event.altKey && event.key === "l") {
      setUpdateInfoList(new Date().getTime());
    }
  };


  const onFiltersChange = (dropdownFilters, txtFilters) => {
    setFilters({
      dropdowns: dropdownFilters,
      txt: txtFilters,
    });
  };
  useEffect(() => {
    if (quoteToOrderList && quoteToOrderList.length > 0) {
      quoteList.forEach((item) => {
        const found = quoteToOrderList.find(
          (quote) => quote.quote_request_id === item.id
        );
        if (found) {
          item.hasVendorSelected = true;
        } else {
          item.hasVendorSelected = false;
        }
      });
      setQuoteList([...quoteList]);
    } else {
      quoteList.forEach((item) => {
        item.hasVendorSelected = false;
      });
      setQuoteList([...quoteList]);
    }
  }, [quoteToOrderList]);

  const requestNextPage = () => {
    setPage((prev) => Math.min(prev + 1, maxPages - 1));
  };
  const onSearch = (value) => {
    setSearch(value);
  };
  //DRAFT
  const isDetailOnDraft = (id) => id in drafts;
  const hasDetailOnDraft = (quoteId, prnId, isRfq) => {
    if (isRfq) {
      return Object.values(drafts).some((draft) => {
        return draft?.quote_request_id?.toString() === quoteId.toString();
      });
    } else {
      return Object.values(drafts).some((draft) => {
        return (
          draft?.quote_request_id?.toString() === quoteId.toString() &&
          draft?.part_request_id?.toString() === prnId.toString()
        );
      });
    }
  };

  const updateDraft = (quoteDetail, section, newValues) => {
    setDrafts((prevDrafts) => {
      const currentDraft = prevDrafts[quoteDetail] || {};
      const updatedDraft = {
        ...currentDraft,
        ...newValues,
      };

      const storageKey = `${localStoragePrefix}/${section}?id=${quoteDetail}&userId=${localStorage.getItem(
        "u_id"
      )}`;
      localStorage.setItem(storageKey, JSON.stringify(updatedDraft));

      return {
        ...prevDrafts,
        [quoteDetail]: updatedDraft,
      };
    });
  };

  const saveDraft = (quoteDetail, section, value) => {
    localStorageSave(
      `${localStoragePrefix}/${section}`,
      { id: quoteDetail },
      value
    );
    setDrafts((prev) => ({
      ...prev,
      [quoteDetail]: value,
    }));
  };

  const removeDraft = (quoteDetail, section) => {
    localStorageRemove(`${localStoragePrefix}/${section}`, {
      id: quoteDetail.toString(),
    });

    setDrafts((prev) => {
      const updatedDrafts = { ...prev };
      delete updatedDrafts[quoteDetail];
      return updatedDrafts;
    });
  };
  //
  useEffect(() => {
    console.log(updateInfoList)
    getQuoteList(page, pageSize, search, sortingOrder)
      .then((response) => {
        if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
          setMaxPages(response.data.totalPages);
          let inventoryArray = response.data.load.map((item) => {
            return { ...item, date_sent: item.date_sent.split("T")[0] };
          });

          setQuoteList((prev) =>
            page > 0 ? [...prev, ...inventoryArray] : [...inventoryArray]
          );
        }
      })
      .catch((error) => setLoadingQuotes(false));
  }, [page]);

  useEffect(() => {
    setPage(0);
    setLoadingQuotes(true);
    getQuoteList(0, pageSize, search, sortingOrder)
      .then((response) => {
        if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
          setMaxPages(response.data.totalPages);
          let inventoryArray = response.data.load.map((item) => {
            return { ...item, date_sent: item.date_sent.split("T")[0] };
          });

          setQuoteList(inventoryArray);
          setLoadingQuotes(false);
        }
      })
      .catch((error) => setLoadingQuotes(false));
  }, [sortingOrder, search, updateInfoList]);
  return (
    <QuoteOrderContext.Provider
      value={{
        quoteList,
        setQuoteList,
        onFiltersChange,
        onSearch,
        loadingQuotes,
        setLoadingQuotes,
        setSortingOrder,
        requestNextPage,
        setUpdateInfoList,
        updateInfoList,
        isOnEdition,
        setIsOnEdition,
        quoteVendorFormState,
        setQuoteVendorFormState,
        setQuoteToOrderList,
        quoteToOrderList,
        page,
        removeDraft,
        saveDraft,
        isDetailOnDraft,
        updateDraft,
        hasDetailOnDraft,
        drafts,
      }}
    >
      {children}
    </QuoteOrderContext.Provider>
  );
};

export { QuoteOrderContext, QuoteOrderContextProvider };
function getDraftContentsByPrefix(prefix) {
  const drafts = {};

  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (!key.startsWith(prefix)) continue;

    const queryParams = new URLSearchParams(key.split("?")[1]);
    if (localStorage.getItem("u_id") !== queryParams.get("userId")) continue;

    const id = queryParams.get("id");

    try {
      const value = JSON.parse(localStorage.getItem(key));
      if (!drafts[id]) drafts[id] = {};
      drafts[id] = value;
    } catch {
      // Si falla el parseo, lo ignoramos
    }
  }

  return drafts;
}
function getObjectsBySection(prefix, section) {
  return [...Array(localStorage.length).keys()]
    .map((i) => localStorage.key(i))
    .filter((key) => key.startsWith(prefix + "/" + section))
    .reduce((acc, key) => {
      const queryParams = new URLSearchParams(key.split("?")[1]);
      if (localStorage.getItem("u_id") === queryParams.get("userId")) {
        const id = queryParams.get("id");
        acc[id] = JSON.parse(localStorage.getItem(key));
      }
      return acc;
    }, {});
}
